import "@/index.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import ScrollToTop from "@/components/ScrollToTop";
import Home from "@/pages/Home";
import About from "@/pages/About";
import Leadership from "@/pages/Leadership";
import Verticals from "@/pages/Verticals";
import Projects from "@/pages/Projects";
import Gallery from "@/pages/Gallery";
import Careers from "@/pages/Careers";
import News from "@/pages/News";
import Contact from "@/pages/Contact";
import WhatsAppFab from "@/components/WhatsAppFab";

export default function App() {
  return (
    <BrowserRouter>
      <ScrollToTop />
      <div className="min-h-screen flex flex-col bg-white text-shramik-ink">
        <Header />
        <main className="flex-1">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/about" element={<About />} />
            <Route path="/leadership" element={<Leadership />} />
            <Route path="/businesses" element={<Verticals />} />
            <Route path="/businesses/:slug" element={<Verticals />} />
            <Route path="/projects" element={<Projects />} />
            <Route path="/gallery" element={<Gallery />} />
            <Route path="/careers" element={<Careers />} />
            <Route path="/news" element={<News />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </main>
        <Footer />
        <WhatsAppFab />
        <Toaster position="top-right" richColors closeButton />
      </div>
    </BrowserRouter>
  );
}
